"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GenericVideoEmbed_1 = require("./GenericVideoEmbed");
const HtmlVideoEmbed_1 = __importDefault(require("./HtmlVideoEmbed"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const TencentVideoEmbed_1 = __importDefault(require("./TencentVideoEmbed"));
const TwitchVideoEmbed_1 = __importDefault(require("./TwitchVideoEmbed"));
const YoutubeVideoEmbed_1 = __importDefault(require("./YoutubeVideoEmbed"));
const classnames_1 = __importDefault(require("classnames"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const styled_components_1 = __importDefault(require("styled-components"));
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
/**
 * BackgroundYouTubeVideo.
 */
/* global MutationObserver */
const BackgroundVideoWrapper = styled_components_1.default.div `
    .video,
    .background-video {
        position: relative;

        &.video {
            position: relative;
            z-index: 0;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background: black;
            background-size: cover;
            &.fixed {
                top: 0;
                left: 0;
                position: fixed;
            }
            &.absolute {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
            }
            .overlay {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(black, 0.25);
                z-index: 1;
            }
            .screen {
                position: absolute;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
                z-index: 0;
                margin: auto;
                @media only screen and (max-width: 767px) {
                    top: 0 !important;
                    min-height: 100%;
                }
                .bkImage {
                    background-size: cover !important;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    &.play-pause-overlay {
        height: 100%;
        position: absolute;
        z-index: 1;
        background: rgba(black, 0.25);
        opacity: 0;
        text-align: center;
        width: 100%;
        top: 0;
        cursor: pointer;
        bottom: 0;
        pointer-events: none;

        &.show {
            opacity: 1 !important;
            pointer-events: auto;
        }

        .play-pause-btn {
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            opacity: 0.85;
            color: #ffffff;
            z-index: 2;
            letter-spacing: 2px;
            text-transform: uppercase;
            transition: opacity 0.3s ease-in-out;
            h4 {
                margin: -1.75em 0 0 0;
                transition: color 0.3s ease-in-out;
                text-shadow: 0 2px 20px #333333;
            }
            a {
                font-size: 6em;
                color: #ffffff;
                display: block;
                text-shadow: 0 2px 20px #333333;
            }
        }

        &:hover {
            .play-pause-btn {
                opacity: 1;
            }
            a,
            h4 {
                color: #7ec0ee;
            }
        }
    }
`;
class BackgroundVideo extends react_1.default.PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            sizeParams: null,
            timeoutId: null
        };
        this.resizeVideo = event => {
            if (!event || this.dead) {
                return;
            }
            this.setVideoBackground();
        };
        this.ratioHelper = p => {
            if (!this.props.enableRatioHelper) {
                return {
                    width: p.bounds.width,
                    height: p.bounds.height,
                    top: 0,
                    left: 0
                };
            }
            const dim = {};
            const ratio = Math.round((p.objectDimensions.width / p.objectDimensions.height) * 1000) / 1000;
            dim.width = p.bounds.width;
            dim.height = Math.round(p.bounds.width / ratio);
            dim.top = Math.round((p.bounds.height - dim.height) / 2);
            dim.bottom = 0;
            dim.left = 0;
            dim.right = 0;
            if (!this.props.leftAlign) {
                dim.bottom = Math.round((p.bounds.height - dim.height) / 2);
            }
            if (dim.height < p.bounds.height) {
                dim.top = 0;
                dim.bottom = 0;
                dim.width = Math.round(p.bounds.height * ratio);
                dim.height = p.bounds.height;
                dim.left = Math.round((p.bounds.width - dim.width) / 2);
                if (!this.props.leftAlign) {
                    dim.right = Math.round((p.bounds.width - dim.width) / 2);
                }
            }
            return dim;
        };
        this.onClickOverlay = event => {
            event.preventDefault();
            if (this.props &&
                this.props.onClickOverlay &&
                typeof this.props.onClickOverlay === 'function') {
                this.props.onClickOverlay(event);
            }
        };
        this.throttleResize = (0, lodash_throttle_1.default)(this.resizeVideo, 250, { leading: false });
        this.dead = false;
        if (process.env.NODE_ENV !== 'production') {
            this.observer = {};
            this.throttleSetVid = (0, lodash_throttle_1.default)(() => {
                this.setVideoBackground();
            }, 50, { leading: false });
        }
    }
    componentDidMount() {
        this.setVideoBackground();
        window_or_global_1.default.addEventListener('resize', this.throttleResize);
        if (process.env.NODE_ENV !== 'production') {
            if (this.parent) {
                let lastHeight;
                let lastWidth;
                let count = 0;
                this.observer = new MutationObserver(mutations => {
                    //eslint-disable-line
                    mutations.forEach(mutation => {
                        if (mutation.target.offsetWidth !== lastWidth &&
                            mutation.target.offsetHeight !== lastHeight &&
                            count < 3) {
                            this.throttleSetVid();
                            count++;
                            lastHeight = mutation.target.offsetHeight;
                            lastWidth = mutation.target.offsetWidth;
                        }
                    });
                });
                this.observer.observe(this.parent, {
                    attributes: true,
                    childList: true,
                    characterData: true
                });
                setTimeout(() => {
                    this.observer.disconnect();
                }, 5000);
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        window_or_global_1.default.setTimeout(() => {
            if (!this.state.sizeParams) {
                this.setVideoBackground();
            }
            else if (this.props.dirty !== prevProps.dirty) {
                this.setVideoBackground();
            }
        }, 0);
    }
    componentWillUnmount() {
        this.dead = true;
        if (this.state.timeoutId) {
            window_or_global_1.default.clearInterval(this.state.timeoutId);
        }
        if (this.observer) {
            this.observer.disconnect();
        }
        window_or_global_1.default.removeEventListener('resize', this.throttleResize);
    }
    setVideoBackground() {
        if (this.dead)
            return;
        const backgroundData = this.props.background;
        if (!backgroundData.type) {
            return; //haven't rendered any content yet so the sizing will be wrong
        }
        const calcDimensions = {
            objectDimensions: {
                width: 1280,
                height: 720
            },
            bounds: {
                width: this.parent && this.parent.offsetWidth ? this.parent.offsetWidth : 0,
                height: this.parent && this.parent.offsetHeight ? this.parent.offsetHeight : 0
            }
        };
        if (calcDimensions.bounds.width === 0 && calcDimensions.bounds.height === 0)
            return;
        const sizeParams = this.ratioHelper(calcDimensions);
        sizeParams.calcFailed = false;
        this.setState({
            sizeParams
        });
    }
    render() {
        const backgroundData = this.props.background;
        const frameSizing = this.state.sizeParams || {};
        // For phones & tablets, show the mobile image if it exists
        const useMobileBg = this.props.mobile && !this.props.forceVideoMobile && backgroundData.mobileImage;
        const useTabletBg = this.props.tablet && !this.props.forceVideoMobile && backgroundData.tabletImage;
        const fixed = (!useMobileBg && this.props.fixed) || false;
        const detatched = this.props.detached;
        const videoClasses = (0, classnames_1.default)('video', {
            'background-video': !detatched,
            fixed,
            absolute: !fixed
        });
        if (!backgroundData || frameSizing.calcFailed) {
            return (react_1.default.createElement("div", { className: videoClasses },
                react_1.default.createElement("div", { ref: c => {
                        this.parent = c;
                    }, className: "screen" })));
        }
        const videoStyle = {};
        const parentStyle = {
            top: frameSizing.top,
            left: frameSizing.left,
            bottom: frameSizing.bottom,
            right: frameSizing.right
        };
        let bkVideo = react_1.default.createElement("div", null);
        if (useMobileBg && backgroundData.mobileImage) {
            videoStyle.background = `url("${backgroundData.mobileImage}") center center no-repeat`;
            videoStyle.backgroundSize = 'cover';
        }
        else if (useTabletBg && backgroundData.tabletImage) {
            videoStyle.background = `url("${backgroundData.tabletImage}") center center no-repeat`;
            videoStyle.backgroundSize = 'cover';
        }
        else {
            switch (backgroundData.type) {
                case 'youtubeVideo': {
                    //be very careful in making changes to the videoOptions as it will cause a full re-render of the iframe
                    const videoOptions = {
                        playerVars: {
                            width: '100%',
                            height: '100%',
                            showinfo: 0,
                            controls: this.props.ytControls ? 1 : 0,
                            autohide: this.props.ytAutohide ? 1 : 0,
                            playsinline: this.props.playsInline ? 1 : 0,
                            cc_load_policy: 0,
                            disablekb: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            rel: 0,
                            loop: 1,
                            playlist: backgroundData.contentId,
                            mute: this.props.mute ? 1 : 0
                        }
                    };
                    bkVideo = (react_1.default.createElement(YoutubeVideoEmbed_1.default, { video: backgroundData.contentId, videoOptions: videoOptions, mute: this.props.mute, loop: true, launcher: this.props.launcher, play: this.props.play }));
                    break;
                }
                case 'twitchStream': {
                    bkVideo = (react_1.default.createElement(TwitchVideoEmbed_1.default, { channel: backgroundData.contentId, play: this.props.play }));
                    break;
                }
                case 'twitchVideo': {
                    bkVideo = (react_1.default.createElement(TwitchVideoEmbed_1.default, { video: backgroundData.contentId, play: this.props.play }));
                    break;
                }
                case 'tencentVideo': {
                    bkVideo = react_1.default.createElement(TencentVideoEmbed_1.default, { videoId: backgroundData.contentId });
                    break;
                }
                case 'htmlVideo': {
                    if (backgroundData.content) {
                        const poster = this.props.mobile
                            ? backgroundData.mobileImage
                            : backgroundData.tabletImage;
                        if (poster) {
                            videoStyle.background = `url(${poster}) center no-repeat`;
                            videoStyle.backgroundSize = 'cover';
                        }
                        bkVideo = (react_1.default.createElement(HtmlVideoEmbed_1.default, { contentId: backgroundData.contentId, content: backgroundData.content, forcePause: this.props.forcePause, playsInline: this.props.playsInline, play: this.props.play, mute: this.props.mute, controls: this.props.controls, onClick: this.onClickOverlay, width: frameSizing.width, height: frameSizing.height }));
                    }
                    else {
                        bkVideo = react_1.default.createElement("div", null);
                    }
                    break;
                }
                case 'embedVideo': {
                    if (backgroundData.embedSrc) {
                        bkVideo = (react_1.default.createElement(GenericVideoEmbed_1.GenericVideoEmbed, { embedSrc: backgroundData.embedSrc, width: frameSizing.width, height: frameSizing.height }));
                    }
                    else {
                        bkVideo = react_1.default.createElement("div", null);
                    }
                    break;
                }
                case 'image': {
                    if (backgroundData.content && backgroundData.content[0]) {
                        videoStyle.background = `url("${backgroundData.content[0]}") center center no-repeat`;
                        videoStyle.backgroundSize = 'cover';
                    }
                    else {
                        bkVideo = react_1.default.createElement("div", null);
                    }
                    break;
                }
                default: {
                    bkVideo = react_1.default.createElement("div", null);
                }
            }
        }
        const videoClassNames = (0, classnames_1.default)('play-pause-overlay', { show: !this.props.play });
        let playPauseOverlay = '';
        if (this.props.playPauseOverlay) {
            playPauseOverlay = (react_1.default.createElement("div", { role: "presentation", className: videoClassNames, onClick: this.onClickOverlay },
                react_1.default.createElement("div", { className: "overlay" }),
                react_1.default.createElement("div", { className: "container-fluid play-pause-btn" },
                    react_1.default.createElement("a", { className: "icon-play" },
                        react_1.default.createElement("i", { className: "path1" }),
                        react_1.default.createElement("i", { className: "path2" })),
                    react_1.default.createElement("h4", null, this.props.message))));
        }
        return (react_1.default.createElement(BackgroundVideoWrapper, { className: videoClasses, style: videoStyle },
            this.props.noOverlay ? '' : react_1.default.createElement("div", { className: "overlay" }),
            playPauseOverlay,
            react_1.default.createElement("div", { ref: c => {
                    this.parent = c;
                }, style: parentStyle, className: "screen" }, bkVideo)));
    }
}
exports.default = BackgroundVideo;
BackgroundVideo.propTypes = {
    fixed: prop_types_1.default.bool,
    background: prop_types_1.default.object,
    detached: prop_types_1.default.bool,
    noOverlay: prop_types_1.default.bool,
    mobile: prop_types_1.default.bool,
    tablet: prop_types_1.default.bool,
    launcher: prop_types_1.default.bool,
    play: prop_types_1.default.bool,
    leftAlign: prop_types_1.default.bool,
    playPauseOverlay: prop_types_1.default.bool,
    forcePause: prop_types_1.default.bool,
    forceVideoMobile: prop_types_1.default.bool,
    message: prop_types_1.default.string,
    dirty: prop_types_1.default.bool,
    enableRatioHelper: prop_types_1.default.bool,
    ytControls: prop_types_1.default.bool,
    controls: prop_types_1.default.bool,
    ytAutohide: prop_types_1.default.bool,
    playsInline: prop_types_1.default.bool,
    onClickOverlay: prop_types_1.default.func,
    mute: prop_types_1.default.bool
};
//# sourceMappingURL=BackgroundVideo.js.map